var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _text, _rect8, _rect9, _path5, _path6, _rect10, _path7, _path8, _rect11, _rect12, _rect13, _text2, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 415.48 492.06",
    "data-imageid": "credit-card-monochromatic-87fa4",
    imageName: "Credit Card",
    className: "illustrations_image",
    style: {
      width: 113
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 275.58,
    y1: 163.16,
    x2: 307.84,
    y2: 394.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 246.44,
    y1: -15.04,
    x2: 66.25,
    y2: 522.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 56.36,
    y1: 224.23,
    x2: 362.26,
    y2: 135.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.31,
    y1: 243.24,
    x2: 275.04,
    y2: 157.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 371.37,
    y1: 383.12,
    x2: 318.51,
    y2: 470.72,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit card 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M457.45,386.78c-9.36,29.18-26,56.92-49.14,76.53q-4.76,4-9.86,7.57a117.87,117.87,0,0,1-18.19,10.4,121,121,0,0,1-13.41,5.2,136.41,136.41,0,0,1-19.74,4.76c-1.23.22-2.48.41-3.72.58l-1.31.18c-26.88,3.6-55.12.44-82.07-4.44-33.45-6.05-66.84-14.67-96.72-30.87-61.45-33.29-103.8-99.4-108.38-169.14-1-15.06-.3-30.36,3.65-44.94C65,218.73,79.28,199.1,96.08,180.8c1.06-1.17,2.15-2.34,3.24-3.49,15.76-16.71,33.4-32.43,48.82-49.44q2.22-2.45,4.37-4.93c.22-.24.43-.49.65-.75l.59-.69.54-.62s.06-.09.1-.13c.82-1,1.63-1.94,2.41-2.92q3-3.63,5.69-7.42c.21-.29.42-.58.62-.88.62-.87,1.22-1.74,1.81-2.63q1.47-2.16,2.85-4.38,1.24-2,2.42-4.08c.49-.86,1-1.73,1.43-2.61q1.41-2.6,2.64-5.26c1.07-2.24,2.05-4.53,3-6.85.5-1.32,1-2.61,1.59-3.9h0a110,110,0,0,1,5-10.11,1,1,0,0,1,.13-.25C230.28-14,380.71-42,448.6,110.88c8.16,18.36,11.14,38.54,13.5,58.48q5.49,46.33,7.28,93C471,304.22,470.23,346.9,457.45,386.78Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#77d495",
    opacity: 0.42,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.44,209.85c4.89,4.75,8.33,10.75,11.72,16.66l25.15,44c4.64,8.12,9.34,16.37,11.52,25.46,1.92,8,1.8,16.37,1.68,24.61l-.76,49c-.13,8.19-.42,16.92-5.05,23.68-7,10.15-21.15,12.19-33.41,11-24.15-2.32-48-14.36-61.2-34.7s-13.94-49.1,1.05-68.17c5.8-7.37,13.82-13.52,16.46-22.52,2.85-9.68-1.71-20.52-9.45-27-5.44-4.55-12.17-7.24-18-11.24s-11.12-10.07-11-17.16C239.41,196.91,296.6,196.43,310.44,209.85Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#fcc5a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310,260.37a90.8,90.8,0,0,0,5.44,35.81c-4.43-.68-7.64-4.39-10.91-7.46s-7.9-5.81-12-4.07a21.51,21.51,0,0,1,2.69,13c-1.42-5.46-7.59-9.82-12.81-7.69-3.29,1.35-5.27,4.68-8,6.92s-7.71,2.88-9.24-.34c11.91-8.94,16.33-24.63,18.7-39.34,1.71-10.6,2.63-45.32,19.09-43.7C321.35,215.32,310.58,249.32,310,260.37Z",
    transform: "translate(-54.51 -1.49)",
    opacity: 0.58,
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.76,
    y: 67.97,
    width: 135.7,
    height: 209.11,
    rx: 11.88,
    fill: "#77d495",
    className: "target-color"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115.68,
    y: 67.97,
    width: 135.7,
    height: 209.11,
    rx: 11.88,
    fill: "#77d495",
    className: "target-color"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.68,
    y: 67.97,
    width: 135.7,
    height: 209.11,
    rx: 11.88,
    opacity: 0.58,
    fill: "url(#linear-gradient-2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180.37,
    y: 81.32,
    width: 37.26,
    height: 42.27,
    rx: 6.59,
    fill: "#fdb523"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.14,124.93h-3.95V112.8a5.45,5.45,0,0,1-3.83-2.68l-.19-.39v-.44c0-1-.28-9.75,0-12.08s2.94-3.95,4.71-4.68V82.87h4V95.46l-1.44.41c-1.59.46-3.15,1.4-3.31,1.86-.17,1.42-.1,7,0,10.79a2.54,2.54,0,0,0,1.89.41l2.16-.2Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#efa92b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.51,124.93h3.95V112.8a5.45,5.45,0,0,0,3.82-2.68l.2-.39v-.44c0-1,.28-9.75,0-12.08s-3-3.95-4.71-4.68V82.87h-3.95V95.46l1.44.41c1.59.46,3.15,1.4,3.3,1.86.18,1.42.1,7,0,10.79a2.57,2.57,0,0,1-1.9.41l-2.15-.2Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#efa92b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 81.41,
    width: 0.83,
    height: 42.17,
    fill: "#efa92b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 185.94,
    y: 81.41,
    width: 0.83,
    height: 42.17,
    fill: "#efa92b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.07,
    y: 81.41,
    width: 0.83,
    height: 42.17,
    fill: "#efa92b"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(203.31 138.21) rotate(90)",
    fontSize: 11.85,
    fill: "#77d495",
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    className: "target-color"
  }, "CREDIT CARD")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105.78,
    y: 85.58,
    width: 135.7,
    height: 209.11,
    rx: 11.88,
    transform: "translate(-100.41 54.1) rotate(-16.09)",
    fill: "#77d495",
    className: "target-color"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101.86,
    y: 86.71,
    width: 135.7,
    height: 209.11,
    rx: 11.88,
    transform: "translate(-100.88 53.05) rotate(-16.09)",
    fill: "#77d495",
    className: "target-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.47,276.2l-107.55,31a11.92,11.92,0,0,1-14.71-8.12L78.83,121A11.89,11.89,0,0,1,87,106.32l49.27-14.21L194.5,75.29a11.9,11.9,0,0,1,14.72,8.12l51.37,178.08A11.89,11.89,0,0,1,252.47,276.2Z",
    transform: "translate(-54.51 -1.49)",
    opacity: 0.58,
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.85,293.44l-49.27,14.21a11.87,11.87,0,0,1-12.37-8.54L78.83,121A11.89,11.89,0,0,1,87,106.32l49.27-14.21a11.89,11.89,0,0,1,12.38,8.54L200,278.73A11.88,11.88,0,0,1,191.85,293.44Z",
    transform: "translate(-54.51 -1.49)",
    opacity: 0.58,
    fill: "url(#linear-gradient-4)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 146.53,
    y: 98.51,
    width: 37.26,
    height: 42.27,
    rx: 6.59,
    transform: "translate(-81.2 48.99) rotate(-16.09)",
    fill: "#fdb523"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.73,140.75l-3.79,1.1-3.37-11.66a5.47,5.47,0,0,1-4.41-1.51l-.3-.33-.13-.42c-.3-.94-3-9.29-3.34-11.61s1.74-4.61,3.24-5.8L153,101.24l3.79-1.09,3.49,12.09L159,113c-1.4.88-2.64,2.23-2.66,2.71.23,1.41,1.84,6.75,3,10.37a2.58,2.58,0,0,0,1.94-.14l2-.78Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#efa92b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.82,138.71l3.79-1.1L175.25,126a5.43,5.43,0,0,0,2.93-3.63l.08-.43-.11-.43c-.25-1-2.44-9.44-3.36-11.6s-3.93-3-5.83-3.18l-2.67-9.28-3.8,1.09L166,110.58h1.5c1.65,0,3.41.48,3.69.88.56,1.31,2,6.7,3,10.37a2.56,2.56,0,0,1-1.71.91l-2.12.41Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#efa92b"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 165.16,
    y: 98.49,
    width: 0.83,
    height: 42.17,
    transform: "translate(-81.17 49.1) rotate(-16.09)",
    fill: "#efa92b"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 152.6,
    y: 102.11,
    width: 0.83,
    height: 42.17,
    transform: "translate(-82.66 45.76) rotate(-16.09)",
    fill: "#efa92b"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 177.71,
    y: 94.86,
    width: 0.83,
    height: 42.17,
    transform: "translate(-79.67 52.44) rotate(-16.09)",
    fill: "#efa92b"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.28, 0.96, -0.96, 0.28, 124.66, 151.3)",
    fontSize: 11.85,
    fill: "#77d495",
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    className: "target-color"
  }, "CREDIT CARD")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.15,300s-26.42-48.38-18.91-53.38,28.36-5.29,35,6.95,5,21.41,8.34,25,14.18,12,14.18,12l26.14,17.8s6,72.29-14.74,67.84S220.15,300,220.15,300Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#fcc5a7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.31,463.31q-4.76,4-9.86,7.57a117.87,117.87,0,0,1-18.19,10.4,121,121,0,0,1-13.41,5.2,136.41,136.41,0,0,1-19.74,4.76c-1.23.22-2.48.41-3.72.58l-1.31.18c-1.38-5.78-2.39-12.88-3.93-17.48-.08-.22-.16-.44-.23-.67-.46-1.35-.92-2.69-1.4-4s-.92-2.58-1.41-3.88q-.8-2.19-1.64-4.37c-.52-1.37-1.05-2.74-1.61-4.1-.45-1.17-.92-2.32-1.41-3.48-.64-1.55-1.3-3.1-2-4.65-.59-1.35-1.18-2.69-1.78-4s-1.2-2.65-1.82-4-1.2-2.59-1.82-3.87c-.44-.9-.87-1.8-1.32-2.69l-.2-.41c-.37-.77-.76-1.54-1.14-2.3l-.6-1.18c-.41-.8-.81-1.59-1.23-2.38-.5-1-1-2-1.55-2.95-5.67-10.62-11-17.85-13.51-24.8-.09-.23-.16-.45-.24-.68-2.64-8-1.36-15.68,7.76-27.82,14.52-19.36,30.77-37.65,47.44-55.18-2.93,3.08-.72,17.43,1.62,29.31,1.35,6.84,2.75,12.86,3.22,15.42a206.37,206.37,0,0,0,9.75,35.31C379.09,413.06,400.9,441,408.31,463.31Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#fcc5a7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M368.36,482.66l-1.51,3.82a136.41,136.41,0,0,1-19.74,4.76c-1.23.22-2.48.41-3.72.58-.08-.4-.17-.73-.25-1q-2.28-8.19-5-16.27c-.08-.22-.16-.44-.23-.67l-1.4-4c-.46-1.29-.93-2.58-1.41-3.88q-.8-2.19-1.64-4.37c-.53-1.37-1.06-2.74-1.61-4.1-.46-1.17-.93-2.32-1.41-3.48-.64-1.55-1.3-3.1-2-4.65l-1.78-4c-.59-1.32-1.2-2.64-1.82-4s-1.2-2.59-1.82-3.87c-.43-.9-.87-1.8-1.32-2.69l-.2-.41c-.37-.77-.76-1.54-1.14-2.3l-.6-1.18c-.4-.8-.81-1.59-1.23-2.38-.5-1-1-2-1.55-2.95-5.67-10.62-11-17.85-13.51-24.8-.09-.23-.16-.45-.24-.68,5,0,19.65.42,27,4.09a4.38,4.38,0,0,1,.48.29C340.15,411.1,368.36,482.66,368.36,482.66Z",
    transform: "translate(-54.51 -1.49)",
    opacity: 0.58,
    fill: "url(#linear-gradient-5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.7,271.9c2.43-1.33,4.43-3.78,4.44-6.54a11.67,11.67,0,0,0-1.4-4.77c-1.73-3.77-3.84-7.81-7.66-9.43-2.88-1.22-6.15-.8-9.24-.36-1.11.16-2.4.44-2.88,1.46a3.23,3.23,0,0,0-.17,1.69,47.57,47.57,0,0,0,5.16,18.1C208,276,214.58,273.62,217.7,271.9Z",
    transform: "translate(-54.51 -1.49)",
    fill: "#fde2d1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenda);
export default __webpack_public_path__ + "static/media/venda.addea30b69ab26ef4ef6b633ce1b9e7e.svg";
export { ForwardRef as ReactComponent };